import "./index.css";
import 'dayjs/locale/de';

/*import "@mantine/core/styles.css";
import '@mantine/dates/styles.css';*/
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "~/App";
import { appRoutes } from "~/constants/appRoutes.ts";
import { IS_MOCK_MODE } from "~/constants/envConstants";
import { reloadApp } from "~/utils/appCacheUtils.ts";

import initI18n from "./i18n/setup";

initI18n({ debug: false });

/**
 * A deploy removes the chunks of the old build. A page of the old build that then loads a lazy page or dialog gets a
 * 404, and the app crashes. A reload gets the new build. A second failure within a minute is not a new deploy, so it
 * does not reload again: that would loop.
 */
const CHUNK_RELOAD_KEY = "chunkReloadAt";
window.addEventListener("vite:preloadError", (event) => {
	const lastReloadAt = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) ?? 0);
	if (Date.now() - lastReloadAt < 60 * 1000) return;
	event.preventDefault();
	sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
	reloadApp();
});

async function startMockWorker() {
	// The mode check lets Vite drop the MSW code from the production build.
	if (!IS_MOCK_MODE) return;
	const { startMocks } = await import("~/mocks/browser");
	await startMocks();
}

startMockWorker().catch(console.error).then(() => {
	ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
		<React.StrictMode>
			<BrowserRouter basename={appRoutes.base().path}>
				<App />
			</BrowserRouter>
		</React.StrictMode>,
	);
});
